import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';
import { stopPropagationMouseEvent } from '@utils/general';

import { ECartPageState, useCartPageContext } from '../../../../context';
import { messages } from '../../messages';

import { StyledLink } from './styled';

export interface IGiftPackagingDescriptionProps extends IBasicStyledProps {
  disabled?: boolean;
  linkUrl?: string;
  showServiceInfoModal: boolean;
}

export const GiftPackagingDescription: ReactFCV<IGiftPackagingDescriptionProps> = ({
  linkUrl = '#',
  disabled = false,
  showServiceInfoModal,
}) => {
  const {
    actions: { setCartPageState },
  } = useCartPageContext();

  const handleMoreInfoClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setCartPageState(ECartPageState.GIFT_PACKAGING_SERVICE_INFO_MODAL);
  };
  return disabled ? (
    <FormattedMessage {...messages.giftWrappingCantCombineDescription} />
  ) : (
    <>
      <FormattedMessage {...messages.giftWrappingDescription} />
      {showServiceInfoModal ? (
        <StyledLink onClick={handleMoreInfoClick}>
          <FormattedMessage {...messages.giftWrappingLinkText} />
        </StyledLink>
      ) : (
        <StyledLink href={linkUrl} onClick={stopPropagationMouseEvent}>
          <FormattedMessage {...messages.giftWrappingLinkText} />
        </StyledLink>
      )}
    </>
  );
};
